import { Sparkle28Filled } from "@fluentui/react-icons";

export const AnswerIcon = () => {
    return <Sparkle28Filled primaryFill={"rgb(0, 110, 181)"} aria-hidden="true" aria-label="Answer logo" />;
};
